import styled from 'styled-components';

import CustomCheckbox from '@components/ui/CustomCheckbox';
import { Caption2 } from '@components/styles/Typography';

const ColorOption = ({ name, color, onColorChange, isSelected }) => (
    <Option
        backgroundColor={color}
        isSelected={isSelected}
        onClick={onColorChange}
    >
        <CustomCheckbox selected={isSelected} backgroundColor={color} />
        <Caption2 color={!isSelected && 'bgGray25'}>{name}</Caption2>
    </Option>
);
const Option = styled.span`
    color: ${({ isSelected, theme }) =>
        isSelected ? `${theme.colors.primary}` : `${theme.colors.bgGray25}`};
    display: flex;
    align-items: center;
    text-transform: uppercase;
    width: calc(100% / 3);
    padding: 20px 0;
    white-space: nowrap;

    span {
        margin-left: 10px;
        cursor: pointer;
    }

    @media (max-width: 1024px) {
        min-width: calc(100% / 2);
    }
`;

export default ColorOption;
